import React, { useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { Anchor, Margin } from '@catalogo/ui-americanas-desktop-product-review/src/components/atoms';
import {
  SelectFilter,
  SelectSort,
  RatingDistribution,
  FilterTag,
} from '@catalogo/ui-americanas-desktop-product-review/src/components/molecules';
import { Title } from '@catalogo/ui-americanas-desktop-review/src/components/atoms';
import { NoReview, RatingAverage } from '../../molecules';
import { HeaderContainer, DataWrapper, SelectsWrapper, DistributionWrapper, FilterTagWrapper } from './Styled';

const Head = (props: any) => {
  const { dispatchMetrics } = props;
  const { data, config, queryParam } = useContext(context);
  const { totalReviews, comments } = data;
  const { productId } = config;
  const href = `/avaliacao/${productId}`;
  const Selects =
    !comments && queryParam?.rating?.length == 0 ? null : (
      <>
        <Title fontSize={18}>comentários</Title>
        <SelectsWrapper>
          <SelectFilter ellipsis left="0px" right="0px" fullWidth dispatchMetrics={dispatchMetrics} />
          <Margin right={8} />
          <SelectSort ellipsis fullWidth dispatchMetrics={dispatchMetrics} />
        </SelectsWrapper>
        <FilterTagWrapper>
          <FilterTag fontSize={14} />
        </FilterTagWrapper>
      </>
    );
  const anchorMetric = () => {
    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'avaliar-produto',
    });
  };
  const AnchorSelect = comments ? (
    <Anchor href={href} fullWidth onClick={anchorMetric}>
      avaliar produto
    </Anchor>
  ) : (
    <Title fontSize={18}>comentários</Title>
  );

  if (!totalReviews) {
    return <NoReview />;
  }

  return (
    <HeaderContainer>
      <DataWrapper>
        <RatingAverage />
        <DistributionWrapper>
          <RatingDistribution dispatchMetrics={dispatchMetrics} />
        </DistributionWrapper>
        <Margin bottom={28} />
        {AnchorSelect}
      </DataWrapper>
      {Selects}
    </HeaderContainer>
  );
};
const Header = React.memo(Head);
export default Header;
export { Header };
